import { render, staticRenderFns } from "./App.vue?vue&type=template&id=f37f2a4c&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f37f2a4c')) {
      api.createRecord('f37f2a4c', component.options)
    } else {
      api.reload('f37f2a4c', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=f37f2a4c&", function () {
      api.rerender('f37f2a4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue/App.vue"
export default component.exports